var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A1733FEE-F7FE-4359-BC57-2FEE9E54848A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 23 0 23 22 0 22"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-Page-Form-3",
    transform: "translate(-925.000000, -669.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(900.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-buttons",
    transform: "translate(0.000000, 448.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-button-2",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "github",
    transform: "translate(25.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.498941,0 C5.14868474,0 0,5.04946255 0,11.2787255 C0,16.2617204 3.29479112,20.4886461 7.86457534,21.9807058 C8.43994598,22.0838691 8.64962092,21.7356065 8.64962092,21.4365021 C8.64962092,21.1692469 8.63973725,20.4595665 8.63408944,19.5186341 C5.43531109,20.1999273 4.7603978,18.0064956 4.7603978,18.0064956 C4.23726941,16.7041455 3.48328678,16.3565752 3.48328678,16.3565752 C2.43914792,15.6572804 3.56235612,15.6711278 3.56235612,15.6711278 C4.71662728,15.7507505 5.32376684,16.8336189 5.32376684,16.8336189 C6.34955032,18.5569307 8.01565426,18.0591158 8.67080021,17.7710894 C8.77528469,17.0420227 9.07179471,16.5449002 9.40077964,16.2631051 C6.84726357,15.9785406 4.16243592,15.0106058 4.16243592,10.6888253 C4.16243592,9.45778945 4.61073084,8.45108184 5.34635808,7.66247114 C5.22775407,7.37721424 4.83311336,6.23064767 5.45860831,4.67765926 C5.45860831,4.67765926 6.42438381,4.37440071 8.62138187,5.83391903 C9.53844501,5.58328068 10.5225759,5.45865388 11.500353,5.45449965 C12.4767181,5.45865388 13.460849,5.58328068 14.3793241,5.83391903 C16.5749102,4.37440071 17.5385678,4.67765926 17.5385678,4.67765926 C18.1661807,6.23064767 17.7715399,7.37721424 17.6529359,7.66247114 C18.3899751,8.45108184 18.8354461,9.45778945 18.8354461,10.6888253 C18.8354461,15.0216837 16.1463826,15.9750788 13.5843949,16.2541043 C13.997391,16.602367 14.3652046,17.2905839 14.3652046,18.342988 C14.3652046,19.8502799 14.3510851,21.066776 14.3510851,21.4365021 C14.3510851,21.7383759 14.5579361,22.0894081 15.1417784,21.9793211 C19.7080328,20.4844918 23,16.2603357 23,11.2787255 C23,5.04946255 17.8506093,0 11.498941,0",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.dad6d1ea.svg";
export { ForwardRef as ReactComponent };